import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/meavatar.png";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
             PERMITA-ME <span className="purple"> APRESENTAR. </span>
            </h1>
            <p className="home-about-body">
              Me apaixonei pela programação e, bom… acho que já aprendi uma ou duas coisas nesse caminho 🤷‍♂️
              <br />
              <br />Trabalho com <i><b className="purple">Java, Node.js, TypeScript, React.js e Python </b></i>, sempre buscando criar sistemas sólidos e escaláveis — seja um CRM, um fluxo automatizado ou uma aplicação de monitoramento em tempo real.
              
                
              
              <br />
              <br />
             Tenho grande interesse em novas tecnologias web, automação e integração com IA, além de explorar ferramentas como n8n e Kafka para tornar processos mais inteligentes.
              
              <br />
              <br />
             Sempre que posso, coloco minha paixão em prática desenvolvendo com <b className="purple">C#, React e Next.js</b> , transformando ideias em soluções modernas, 
             limpas e de alta performance.
              
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>
              CONECTE-SE COMIGO
            </h1>
            <p>
              Sinta-se à vontade para <span className="purple">conectar </span>comigo
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/luizbarrosj"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://x.com/luizbarro82"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/luizbarrosdev/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/luizbarros_1/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
